// src/components/Checkout/ReceiverAddressFields.tsx

import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { getCountriesWithPlaceholder } from "@/constants/countries";
import styles from "./Checkout.module.scss";

interface ReceiverAddressFieldsProps {
  receiverCountry: string;
  setReceiverCountry: (value: string) => void;
  receiverFirstName: string;
  setReceiverFirstName: (value: string) => void;
  receiverLastName: string;
  setReceiverLastName: (value: string) => void;
  receiverAddress: string;
  setReceiverAddress: (value: string) => void;
  receiverEmail: string;
  setReceiverEmail: (value: string) => void;
  receiverCity: string;
  setReceiverCity: (value: string) => void;
  receiverPostal: string;
  setReceiverPostal: (value: string) => void;
  receiverPhone: string;
  handleReceiverPhoneChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleBlurPhone: () => void;
  errors: {
    receiverPhone?: string;
  };
}

export const ReceiverAddressFields: React.FC<ReceiverAddressFieldsProps> = ({
  receiverCountry,
  setReceiverCountry,
  receiverFirstName,
  setReceiverFirstName,
  receiverLastName,
  setReceiverLastName,
  receiverAddress,
  setReceiverAddress,
  receiverEmail,
  setReceiverEmail,
  receiverCity,
  setReceiverCity,
  receiverPostal,
  setReceiverPostal,
  receiverPhone,
  handleReceiverPhoneChange,
  handleBlurPhone,
  errors,
}) => {
  const { t } = useTranslation("common");

  const countryOptions = useMemo(() => {
    const countries = getCountriesWithPlaceholder(
      t("checkout.form.selectCountry")
    );
    return countries.map((c) =>
      c.isDivider ? (
        <option key={c.code} value="" disabled>
          {c.label}
        </option>
      ) : (
        <option key={c.code} value={c.code}>
          {c.label}
        </option>
      )
    );
  }, [t]);

  return (
    <>
      <div className={styles.formRow}>
        <select
          className={styles.select}
          value={receiverCountry}
          required
          onChange={(e) => setReceiverCountry(e.target.value)}
        >
          {countryOptions}
        </select>
      </div>

      <div className={styles.formRow}>
        <input
          type="text"
          placeholder={t("checkout.receiver.firstName")}
          value={receiverFirstName}
          required
          onChange={(e) => setReceiverFirstName(e.target.value)}
        />
        <input
          type="text"
          placeholder={t("checkout.receiver.lastName")}
          value={receiverLastName}
          required
          onChange={(e) => setReceiverLastName(e.target.value)}
        />
      </div>

      <div className={styles.formRow}>
        <input
          type="text"
          placeholder={t("checkout.receiver.address")}
          value={receiverAddress}
          required
          onChange={(e) => setReceiverAddress(e.target.value)}
        />
      </div>

      <div className={styles.formRow}>
        <input
          type="email"
          placeholder={t("checkout.receiver.email")}
          value={receiverEmail}
          required
          autoComplete="email"
          onChange={(e) => setReceiverEmail(e.target.value)}
        />
      </div>

      <div className={styles.formRow}>
        <input
          type="text"
          placeholder={t("checkout.receiver.city")}
          value={receiverCity}
          required
          onChange={(e) => setReceiverCity(e.target.value)}
        />
        <input
          type="text"
          placeholder={t("checkout.receiver.postal")}
          value={receiverPostal}
          required
          onChange={(e) => setReceiverPostal(e.target.value)}
        />
      </div>

      <div className={styles.formRow}>
        <input
          type="tel"
          placeholder={t("checkout.receiver.phone")}
          value={receiverPhone}
          required
          onChange={handleReceiverPhoneChange}
          onBlur={handleBlurPhone}
          style={{
            backgroundColor: errors.receiverPhone ? "#FFB3B3" : "",
            outline: errors.receiverPhone ? "1px solid red" : "",
          }}
        />
      </div>
    </>
  );
};
